import {
  APIProvider,
  ControlPosition,
  Map as GoogleMap,
} from "@vis.gl/react-google-maps";
import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import corporationService from "../../../../../../services/web/corporation-service.js";
import MapContent from "./map-content.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";

const mapIds = projectUtils.googleMapsIds();

const OccurrenceMappingMap = ({ data }) => {
  const [position, setPosition] = useState(null);
  const [mapState, setMapState] = useState({
    neighborhoodStreets: true,
    pointsOfInterest: false
  })
  const [currentMap, setCurrentMap] = useState('default');

  const { data: corporation = null, isSuccess } = useQuery({
    queryFn: () => corporationService.entity(),
    queryKey: ["corporation"]
  });

  useEffect(() => {
    if (!corporation) return;

    const lat = parseFloat(corporation?.latitude) || 0;
    const lng = parseFloat(corporation?.longitude) || 0;

    setPosition({ lat, lng });
  }, [corporation]);

  useEffect(() => {
    if(mapState.pointsOfInterest && mapState.neighborhoodStreets){
      setCurrentMap("poi-street");
    } else if(!mapState.pointsOfInterest && !mapState.neighborhoodStreets){
      setCurrentMap("nopoi-nostreet")
    } else if(mapState.pointsOfInterest && !mapState.neighborhoodStreets){
      setCurrentMap("poi-nostreet")
    } else {
      setCurrentMap("default");
    }

  }, [mapState.neighborhoodStreets, mapState.pointsOfInterest]);

  if (!isSuccess || !position) return null;

  return (
    <div>
      <APIProvider apiKey={corporation?.maps_api_key ?? ""} language="pt-BR">
        <GoogleMap
          mapId={mapIds[currentMap]}
          defaultZoom={13}
          defaultCenter={position}
          reuseMaps={true}
          gestureHandling="greedy"
          style={{ height: "450px", width: "100%" }}
          fullscreenControl={true}
          mapTypeControl={true}
          fullscreenControlOptions={{ position: ControlPosition.TOP_RIGHT }}
          mapTypeControlOptions={{ position: ControlPosition.TOP_LEFT }}
          streetViewControlOptions={{ position: ControlPosition.RIGHT_BOTTOM }}
          streetViewControl={false}
        >
          <MapContent
            data={data}
            mapState={mapState}
            setMapState={setMapState}
          />
        </GoogleMap>
      </APIProvider>
      <div className="chart-divisor"></div>
    </div>
  );
};

export default OccurrenceMappingMap;